





































import {Component, Prop, Mixins} from 'vue-property-decorator'
import HistoryItem from '@/components/HistoryItem.vue'
import PlaceholderCard from "@/components/cards/PlaceholderCard.vue";
import onLocaleChangeMixin from '@/mixins/onLocaleChangeMixin'
import {IHistory, IRequestExtended} from "@/entities";
import {StatusTagType, StatusTagTypeArray} from "@/components/lib/models";

@Component({
  components: {
    HistoryItem,
    PlaceholderCard
  }
})
export default class HistorySection extends Mixins(onLocaleChangeMixin) {

  @Prop() readonly fetchMethod?: (payload?: IRequestExtended) => Promise<IHistory[]>
  @Prop({
    default: () => ((status: string): StatusTagType => {
      return StatusTagTypeArray.map(s => s as string).indexOf(status) === -1 ? 'none' : status as StatusTagType;
    })
  }) readonly mapMethod?: (status?: string) => StatusTagType
  @Prop({ default: 'statuses.entities.order' }) readonly scope?: string
  @Prop({ default: false }) readonly dialog?: boolean
  @Prop({ default: false }) readonly forceLoading?: boolean
  @Prop() readonly itemClass?: string
  @Prop() readonly records?: IHistory[]

  protected initFetches = [
    this.fetchHistories
  ];

  protected fetching: boolean = false;

  protected histories: IHistory[] = [];
  get historiesToShow(): IHistory[] {
    const histories = this.records?.length ? this.records : this.histories;
    return histories.filter(history => history.validate());
  }

  private fetchHistories(): void {
    if (this.records) {
      this.histories = this.records;
    } else if (this.fetchMethod) {
      if (!this.histories?.length) {
        this.fetching = true;
        this.fetchMethod()
          .then(res => {
            this.histories = res;
          })
          .catch(() => {})
          .finally(() => {
            this.fetching = false;
          });
      }
    }
  }

  get loading(): boolean {
    return this.forceLoading || this.fetching;
  }

  get mayHaveItems(): boolean {
    return !!this.historiesToShow.length || this.loading;
  }

}
